import { useState } from 'react';
import { ShareResultMail, ShareResultWhatsapp } from './ShareResult';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';
import { Alert, Popover } from '@mui/material';

const ShareButtons = ({ subject, informationToShare }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const onCloseHandler = () => {
    setIsCopied(false);
    setAnchorEl(null);
  };

  const handleOnCopyClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      onCloseHandler();
    }, 2000);
  };
  return (
    <>
      <ShareResultMail subject={subject} info={informationToShare} />
      <ShareResultWhatsapp info={informationToShare} />
      <CopyToClipboard
        text={informationToShare}
        onCopy={() => {
          setIsCopied(true);
        }}
        options={{ format: 'text/plain' }}
      >
        <IconButton style={{ verticalAlign: 'top', backgroundColor: '#7F7F7F', padding: '6px', marginLeft: '4px' }} onClick={handleOnCopyClick}>
          <ContentCopyIcon style={{ height: '20px', width: '20px' }} />
        </IconButton>
      </CopyToClipboard>
      <Popover
        open={isCopied}
        anchorEl={anchorEl} // Anchor to the button element
        onClose={onCloseHandler}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{ vertical: -15, horizontal: 'center' }}
      >
        <Alert severity="info" sx={{ width: '100%' }}>
          Copied to clipboard!
        </Alert>
      </Popover>
    </>
  );
};

export default ShareButtons;
